import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { IClientApiResponse } from '~/clientApi';
import { mapCreatorsFromApiModelToViewModel } from '~/clientApi/clientApi.mapper';
import { Creator } from '~/clientApi/creator.model';
import { CREATORS_COLLECTION_QUERY_KEY } from '~/queries/keys';
import { selectTalentManager } from '~/selectors/talent-manager';

import { getCreators } from './useCreators.api';

export interface IUseCreatorsParams {
  enableAgencyRoster?: boolean;
  useQueryOptions?: UseQueryOptions<IClientApiResponse<Creator>>;
}

export function useCreators({
  enableAgencyRoster,
  useQueryOptions,
}: IUseCreatorsParams = {}) {
  const manager = useSelector(selectTalentManager);
  const agencyId: string | undefined = enableAgencyRoster
    ? manager?.agency?.id
    : undefined;

  const { data: { results: creatorResults = [] } = {}, ...rest } = useQuery(
    [
      CREATORS_COLLECTION_QUERY_KEY,
      { managerId: manager?.id, agencyId, enableAgencyRoster },
    ],
    () => getCreators(agencyId),
    {
      enabled: !!manager?.id,
      ...useQueryOptions,
    },
  );

  const creators = mapCreatorsFromApiModelToViewModel(creatorResults);

  return {
    creators,
    ...rest,
  };
}
